import REDUCER_KEY from 'reducers/reducer.keys';

const config = {
  user: {
    ...REDUCER_KEY.userCollectionValues,
    placeholder: 'user details',
    theme: 'user'
  },
  activity: {
    ...REDUCER_KEY.activityCollectionValues,
    placeholder: 'activity details',
    theme: 'activity'
  },
  showUserFilter: true,
  showActivityFilter: true
};

export default config;
